export default function themeTypography(theme) {
  return {
    fontFamily: ["Montserrat", "sans-serif"].join(","),
    allVariants: {
      fontFamily: ["Montserrat", "sans-serif"].join(","),
    },
  };
}
